import { ActionIcon, Menu, Text } from "@marketplace/ui";
import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { MdMoreVert } from "react-icons/md";

import { RouterLink } from "@/components";

import {
  deleteSellerModalAtom,
  resendVerificationModalAtom
} from "../../atoms";
import type { SellerListItem } from "../../types";

type SellerListTableActionsProps = {
  sellerData: SellerListItem;
};

export const SellerListTableActions = ({
  sellerData
}: SellerListTableActionsProps) => {
  const { t } = useTranslation("users", {
    keyPrefix: "sellerListPage.sellerListTable.tableActions"
  });
  const setDeleteSellerModal = useSetAtom(deleteSellerModalAtom);
  const setResendVerificationModal = useSetAtom(resendVerificationModalAtom);

  const isVerified = sellerData.attributes?.status === "active";

  const handleDelete = () => {
    try {
      setDeleteSellerModal({
        visible: true,
        data: sellerData
      });
    } catch (e) {
      console.error(e);
    }
  };

  const handleResendVerification = () => {
    try {
      setResendVerificationModal({
        visible: true,
        data: sellerData
      });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Menu width={180} position="bottom-end">
      <Menu.Target>
        <ActionIcon variant="transparent" className="text-fjord-grey-500">
          <MdMoreVert size={24} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          classNames={{
            item: "!p-0"
          }}
        >
          <RouterLink
            className="p-[14px] block"
            to="/users/sellers/$sellerId"
            underline="never"
            params={{ sellerId: sellerData.id }}
          >
            <Text size="s" className="text-fjord-grey-500">
              {t("edit")}
            </Text>
          </RouterLink>
        </Menu.Item>
        {!isVerified && (
          <Menu.Item onClick={handleResendVerification}>
            <Text size="s" className="text-fjord-grey-500">
              {t("resendVerification")}
            </Text>
          </Menu.Item>
        )}
        <Menu.Item onClick={handleDelete}>
          <Text size="s" className="text-fjord-grey-500">
            {t("delete")}
          </Text>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
